import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { track } from 'core/helpers/analytics';
import { AssurityLifeModal } from 'common/components/assurity-life-modal/assurity-life-modal';
import { AssurityOffer } from 'common/components/assurity-offer/assurity-offer';
import { BranchAutoUpsell } from 'common/components/branch-auto-upsell';
import Section from 'core/components/section';
import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import PropTypes from 'prop-types';

export const CustomerAdditionalOffersSection = observer(function CustomerAdditionalOffersSection({
  assurityTermLife = false,
  assurityTermLifeData,
  bixAutoUpsellInput = null
}) {
  const {
    account: { policies, id },
    additionalOffers
  } = useStore();
  const {
    user: { affinityCode }
  } = useSession();
  const policy = policies.getRecentPolicy(); // Using getRecentPolicy() here as per discussion in issue #21742 - additional offers don't require an active policy
  const webUserId = policy?.webUserId;
  const location = window.location.href;

  useEffect(() => {
    if (webUserId && webUserId !== additionalOffers?.webUserId) {
      additionalOffers.getAdditionalOfferData(webUserId);
    }
  }, [webUserId, additionalOffers]);

  const [showAssurityTermLifeModal, setShowAssurityTermLifeModal] = useState(false);

  const allPeople = policies.list.reduce(
    (acc, policy) => [
      ...acc,
      ...(policy.policyDetails.people || []),
      ...(policy.policyDetails.drivers || []),
      ...(policy.policyDetails.nonDrivers || [])
    ],
    []
  );

  const openAssurityTermLifeModal = () => {
    setShowAssurityTermLifeModal(true);
    track('Agent Clicked View Life Offer', {
      URL: location,
      preBindId: webUserId,
      accountId: id,
      affinityCode
    });
  };

  // The BIX upsell card can decide to hide itself after its on-mount mutation rejects
  // or errors — don't leave the "Additional Offers" section header orphaned in that case.
  const [bixUpsellHidden, setBixUpsellHidden] = useState(false);
  const assurityWillRender = assurityTermLife && assurityTermLifeData?.eligibleLifeOffers?.length > 0;
  const bixUpsellWillRender = !!bixAutoUpsellInput && !bixUpsellHidden;
  const showSection = assurityWillRender || bixUpsellWillRender;

  return (
    <>
      {showSection && (
        <Section title="Additional Offers">
          {assurityWillRender && (
            <AssurityOffer
              assurityTermLifeData={assurityTermLifeData}
              allPeople={allPeople}
              onOpenOffersClicked={openAssurityTermLifeModal}
            />
          )}
          {bixAutoUpsellInput && (
            <BranchAutoUpsell input={bixAutoUpsellInput} source="customer" onHide={() => setBixUpsellHidden(true)} />
          )}
        </Section>
      )}
      {showAssurityTermLifeModal && (
        <AssurityLifeModal
          assurityData={assurityTermLifeData}
          open={showAssurityTermLifeModal}
          onClose={() => setShowAssurityTermLifeModal(false)}
          people={allPeople}
        />
      )}
    </>
  );
});

CustomerAdditionalOffersSection.propTypes = {
  assurityTermLife: PropTypes.bool,
  assurityTermLifeData: PropTypes.object,
  bixAutoUpsellInput: PropTypes.object
};
